import React, { useState } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import { AiOutlineShoppingCart, AiOutlineUser } from "react-icons/ai";
import "./style.css"

export default function Mobile() {
  const [show, setShow] = useState(false);

  return (
    <>
      {/* TOP MOBILE NAVBAR */}
      <Nav
        className="navbar shadow d-lg-none"
        style={{
          backgroundColor: "#88C273",
          position: "sticky",
          top: 0,
          zIndex: 1050,
        }}
      >
        <div className="container d-flex justify-content-between align-items-center">
          {/* LOGO */}
          <Link to="/">
            <img src={Logo} height="50" alt="logo" />
          </Link>

          {/* MENU BUTTON */}
          <button
            className="navbar-toggler border-0"
            onClick={() => setShow(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </Nav>

      {/* SIDEBAR / OFFCANVAS */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="start"
        className="d-lg-none sidebar-width"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={Logo} height="40" alt="logo" />
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <ul className="nav flex-column gap-2">
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setShow(false)}>
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link"
                to="/herbalProduct"
                onClick={() => setShow(false)}
              >
                Herbal Products
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link"
                to="/gardenProduct"
                onClick={() => setShow(false)}
              >
                Garden Products
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link"
                to="/foodProduct"
                onClick={() => setShow(false)}
              >
                Food Products
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link"
                to="/about"
                onClick={() => setShow(false)}
              >
                About
              </Link>
            </li>

            <hr />

            <li className="nav-item">
              <Link
                to="/cart"
                className="nav-link"
                onClick={() => setShow(false)}
              >
                <AiOutlineShoppingCart size={22} /> Cart
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/profile"
                className="nav-link"
                onClick={() => setShow(false)}
              >
                <AiOutlineUser size={22} /> Profile
              </Link>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
